export default __webpack_public_path__ + "alberta-humidification.010c0366e66632fe30f4.svg";